import {types} from './types';

export const setTimeFormat = (format) => {
    if (format === 12) {
        return {
            type: types.SET_12_HOUR_TIME_SUCCESS,
        }
    }
    if (format === 24) {
        return {
            type: types.SET_24_HOUR_TIME_SUCCESS,
        }
    }
    return;
} 


// WEBPACK FOOTER //
// ./src/js/actions/time-actions.js